import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SowStatusTable from './SowStatusTable';
import _ from 'lodash';

/**
 * @typedef {object} SowStatusSectionProps
 * @property {boolean} [loading]
 * @property {Array<*>} [data]
 * @property {string} [atlName]
 * @property {string} [atlObserverName]
 * @property {Array<*>} [orgUnitNames]
 * @property {Date} [eventStartDate]
 * @property {(eventFormData: Object | ((prev: Object) => Object)) => void} setEventFormData
 * @property {Array<*>} [sowStatusesErrors]
 */

/**
 * @param {SowStatusSectionProps} props
 */
const SowStatusSection = props => {
  const {
    loading = false,
    data = [],
    atlName,
    atlObserverName,
    orgUnitNames,
    eventStartDate,
    setEventFormData,
    sowStatusesErrors = []
  } = props;

  const sortedData = _.sortBy(data, status => {
    return [status.statusType, status.atmType, status.atmName?.toLowerCase()];
  });

  return (
    <Accordion
      data-testid='sow-section'
      slotProps={{
        transition: { unmountOnExit: true }
      }}
      defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon data-testid='comment-expand-icon' />}>
        <h3>SOW Status</h3>
      </AccordionSummary>
      <AccordionDetails>
        <SowStatusTable
          loading={loading}
          data={sortedData}
          atlName={atlName}
          atlObserverName={atlObserverName}
          orgUnitNames={orgUnitNames}
          eventStartDate={eventStartDate}
          setEventFormData={setEventFormData}
          sowStatusesErrors={sowStatusesErrors}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default SowStatusSection;
